const Pagination = () => {
    return(
        <ul className={'pagination'}>
            <li>1</li>
            <li>2</li>
            <li className={'active'}>3</li>
            <li>4</li>
            <li>5</li>
        </ul>
    )
}

export default Pagination;
